
define('text!common/views/commercial/creatives/logo-header.html',[],function () { return '<h3 class="ad-slot--paid-for-badge__header"><%=header%></h3>\n';});

